<template>
  <div class="main-bg">
    <el-button
      size="mini"
      type="primary"
      @click="handleAdd">新增</el-button>
    <div class="container">
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="afficheTitle"
          align="center"
          :show-overflow-tooltip="true"
          label="公告标题">
        </el-table-column>
        <el-table-column
          prop="afficheContent"
          align="center"
          :show-overflow-tooltip="true"
          label="公告内容">
        </el-table-column>

        <el-table-column
          prop="sentAmount"
          align="center"
          label="发送人数">
        </el-table-column>
        <el-table-column
          prop="afficheStatus"
          align="center"
          label="状态">
          <template slot-scope="scope">
            {{scope.row.afficheStatus==1002?'上架':'下架'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="创建时间">
          <template slot-scope="scope">
            {{timestampToTime(scope.row.createTime)}}
          </template>
        </el-table-column>
        <el-table-column
        prop="status"
        label="操作"
        width="250"
        fixed="right"
        align="center">
        <template slot-scope="scope">
        <el-button
        size="mini"
        type="primary"
        v-if="scope.row.sentAmount==0"
        @click="handleDetail(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="handleDetail(scope.row,'see')">查看</el-button>
        <el-button
          size="mini"
          type="primary"
          v-if="scope.row.sentAmount==0"
          @click="handleSend(scope.row)">发布</el-button>
        </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        style="float: right;margin-top: 20px;"
        :page-size="10"
        background
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <!--新增弹窗-->
    <el-dialog title="新增"  :visible.sync="addFlag" width="80%" append-to-body class="my-label">
      <el-form :model="ruleForm"  :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="公告标题" prop="afficheTitle">
              <el-input :disabled="disabled" v-model="ruleForm.afficheTitle"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="公告内容" prop="afficheContent">
              <vue-editor :disabled="disabled" v-model="ruleForm.afficheContent" />
            </el-form-item>
          </el-col>
        </el-row>
        <div style="text-align: right">
          <el-form-item>
            <el-button type="primary"  @click="submitForm('ruleForm')">确 定</el-button>
            <el-button @click="addFlag=false">取 消</el-button>
          </el-form-item>
        </div>

      </el-form>
    </el-dialog>


  </div>
</template>

<script>
  import {getDogsAfficheListPage,saveDogsAffiche,sendMerchantAfficheAll,updateDogsAffiche  } from '@/api/notice'
  import { VueEditor } from "vue2-editor";
  export default {
    name: "notice",
    components: { VueEditor },
    data(){
      return{
        pageNum:1,
        checkFlag:false,
        tableData:[],
        disabled:false,
        total:0,
        checkFrom:{},
        rules:{
          afficheTitle: [
            { required: true, message: '请输入公告标题', trigger: 'blur' }
          ],
          afficheContent: [
            { required: true, message: '请输入公告内容', trigger: 'blur' }
          ],

        },
        ruleForm:{

        },
        addFlag:false,
      }
    },
    mounted(){
      this.getList()
    },
    methods:{
      handleSend(row){
        this.$confirm('将发送该公告给所有人, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let body={
            afficheId:row.afficheId
          }
          let res = await sendMerchantAfficheAll({body})
          this.$message({
            type: 'success',
            message: '已发送成功'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发送'
          });
        });
      },
      handleAdd(){
        this.addFlag=true
        this.disabled=false
        this.$refs.ruleForm.resetFields();
        this.ruleForm={}
      },
      async getList(){
        let body={
          "pageSize": 10, //每页条数
          "pageNum": this.pageNum, //当前页
          table:{}
        }
        let res = await getDogsAfficheListPage({body})
        this.tableData=res.body.list
        this.total=res.body.totalCount
      },
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            let body={
              ...this.ruleForm
            }
            if(this.ruleForm.afficheId){
              // 修改
              let res=await updateDogsAffiche({body})
              if (res.code=='2000'){
                this.$message.success('修改成功')
                this.getList()
                this.addFlag=false
              }else{
                this.$message.error(res.msg)
              }
            }else{
              // 添加
              let res=await saveDogsAffiche({body})
              if (res.code=='2000'){
                this.$message.success('添加成功')
                this.getList()
                this.addFlag=false
              }else{
                this.$message.error(res.msg)
              }
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDetail(row,see){
        this.addFlag=true
        this.ruleForm=row
        if(see=='see'){
          this.disabled=true
        }else{
          this.disabled=false
        }
        this.$refs.ruleForm.resetFields();
      },
      handleCurrentChange(val){
        this.pageNum=val
        this.getList()
      },
      timestampToTime(timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        return Y+M+D;
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/notice.vue